var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Sum.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Sum = ({
  color = '#0D9966',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#0D9966"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16 8L16 7.4C16 7.17909 15.8209 7 15.6 7L9.24837 7C8.74527 7 8.46557 7.58196 8.77985 7.97482L12 12L8.77985 16.0252C8.46557 16.418 8.74527 17 9.24837 17L15.6 17C15.8209 17 16 16.8209 16 16.6L16 16",
    stroke: "white",
    strokeWidth: "2.8",
    strokeLinecap: "round"
  })]
});